export default __webpack_public_path__ + "static/subset-SuisseIntl-Medium-30c27cc7ed528a534d9808da1e705669.woff2";